import {
  Box,
  Divider,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { RendererContext } from "../contexts/rendererContext";
import { Color } from "three";
import { T } from "./T";

const TerrainOptions = () => {
  const rendererContext = useContext(RendererContext);
  const viewer = rendererContext.viewer;
  const [floorColor, setFloorColor] = useState("#2a6e3c");
  const [isGrassTexture, setGrassTexture] = useState(false);

  useEffect(() => {
    // @ts-ignore
    const grassTextureActive = !!viewer?.floor.mesh.material.map;
    setGrassTexture(grassTextureActive);

    // @ts-ignore
    const floorColor = viewer?.floor.mesh.material.color;

    setFloorColor(`#${floorColor.getHexString()}`);
  }, []);

  return (
    <Box
      sx={{
        overflowY: "auto",
      }}
    >
      <Typography variant="h6">
        <T str="Terrain Options" />
      </Typography>
      <Divider
        sx={{
          backgroundColor: "primary.contrastText",
          margin: "1rem 0",
        }}
        variant="fullWidth"
      />
      <TableContainer
        component={Paper}
        sx={{
          backgroundColor: "primary.light",
          color: "primary.contrastText",
        }}
      >
        <Table>
          <TableBody>
            <TableRow>
              <TableCell>
                <T str="Default Floor color" />
              </TableCell>
              <TableCell>
                <input
                  type="color"
                  value={floorColor}
                  onChange={(event) => {
                    viewer?.floor.setPlainFloor(new Color(event.target.value));
                    setFloorColor(event.target.value);
                    setGrassTexture(false);
                  }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <T str="Use Grasstexture" />
              </TableCell>
              <TableCell>
                <Switch
                  checked={isGrassTexture}
                  aria-label=""
                  color="secondary"
                  onClick={() => {
                    if (isGrassTexture) {
                      viewer?.floor.setPlainFloor(new Color("#2a6e3c"));
                    } else {
                      viewer?.floor.setGrassFloor();
                    }
                    setGrassTexture(!isGrassTexture);
                    setFloorColor("#2a6e3c");
                  }}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default TerrainOptions;
